import request from '@/utils/request'


export const getUserStatus = () => {
  return request({
    url: '/system/saleScheduleConfig/getUserStatus',
    method: 'get'
  })
}

export const checkUserStatus = (params) => {
  return request({
    url: '/system/saleScheduleConfig/checkUserStatus',
    method: 'get',
    params
  })
}